import Vue from 'vue'
import Vuex from 'vuex'
import request from '../plugins/request.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  token:'',
	  user:{
		  ali_real_name:null,
		  center_id:null
	  },
	  uper:'',
	  reload:false
  },
  getters: {
  },
  mutations: {
  },
  actions: {
	  setReload({state},reload){
		  state.reload = reload
	  },
	  setUper({state},data){
		  state.uper = data
	  },
	  initUser({state}){
	  		let token =   window.localStorage.getItem('token')
			let user = window.localStorage.getItem('user')
	  		if(token){
	  			state.token = token
	  		}
			if(user){
				state.user = JSON.parse(user)
				console.log(state.user)
			}
	  },
	  login({
	  	state,
	  	dispatch
	  }, token) {
	  	window.localStorage.setItem('token', token)
		window.localStorage.setItem('user', JSON.stringify(state.user))
	  	dispatch('initUser')
		return dispatch('setUserInfo').catch(() => state.user)
	  },
	  setUserInfo({state}){
		  return request.post('/verify_center/v1_0_1.Mine/CenterInfo',{
			  fields:[
			    "software_num",
			    "wechat_info",
			    "center_id",
			    "endtime",
			    "not_read_notice_num",
			    "money",
			    "quanlang_id",
			    "high_data_endtime",
			    "is_certify",
			    "ali_real_name",
			    "wx_openid"
			  ]
		  }).then(res=>{
			  if(res.data){
				  state.user.ali_real_name = res.data.ali_real_name
				  state.user.center_id = res.data.center_id
				  state.user.wx_openid = res.data.wx_openid
				  state.user.not_read_notice_num = res.data.not_read_notice_num
				  window.localStorage.setItem('user',JSON.stringify(state.user))
			  }
			  return state.user
		  })
	  },
	  // 清除登录状态
	  logout({
	  	state
	  }) {
	  	state.token = null
		state.user = {
			ali_real_name:null,
			center_id:null
		}
	  	window.localStorage.removeItem('token')
		window.localStorage.removeItem('user')
	  }
  }
})
